<template>
  <div class="viewer">
    <div class="selected">
      <div
          class="mh-inherit d-flex flex-column align-center justify-center"
      >
        <div class="d-flex" v-if="images.length">
          <m-image-viewer
              :src="getFileUrl(images[0])"
              :audio-bg="bgFile"
              :time-left-media="timeLeft"
              :time_restriction_media="time_restriction_media"
          />
          <m-image-viewer v-if="isManyImages"
                          :src="getFileUrl((images[1]))"
                          :time-left-media="timeLeft"
                          :time_restriction_media="time_restriction_media"
                          class="ml-2"
                          :audio-bg="bgFile"/>
        </div>
        <!--          TODO переносится-->
<!--        <div class="mt-5">-->
<!--          <m-audio-panel-->
<!--              style="width: -webkit-fill-available"-->
<!--              v-if="bgFile"-->
<!--              :bgAudio="bgFile"-->
<!--              :autoplay="!isQuestionFinished"-->
<!--          />-->
<!--        </div>-->
      </div>
      <div class="content mh-inherit">
        <video
            style="max-height: 600px; width: -webkit-fill-available"
            v-if="files[selectedFileIdx].type.startsWith('video')"
            :src="getFileUrl(files[selectedFileIdx])"
            controls
            :autoplay="!isQuestionFinished"
        />
      </div>

      <div class="content"
           v-if="files[selectedFileIdx].type.startsWith('audio')"
      >
        <div
            v-if="bgFile"
            class="content-with-img-bg"
        >
          <img
              class="img-bg"
              :src="getFileUrl(bgFile)"
          >
          <audio
              class="content-audio-with-bg"
              :src="getFileUrl(files[selectedFileIdx])"
              controls
              :autoplay="!isQuestionFinished"
          />
        </div>


        <m-audio-player :audioSrc="getFileUrl(files[selectedFileIdx])" class="mx-auto"></m-audio-player>
      </div>
    </div>
  </div>
</template>

<script>
import MAudioPlayer from "@/components/widgets/Audio/m-audio-player.vue";
import MImageViewer from "@/components/widgets/m-image-viewer.vue";
import { getFileUrl } from "@/assets/helpers/getFileUrl";

export default {
  name: "m-new-media-viewer" ,
  components: {MAudioPlayer, MImageViewer},
  props: {
    files: {
      type: Array,
      required: true,
    },
    bgFile: {
      type: Object,
      default: null,
    },
    isQuestionFinished: {
      type: Boolean,
      default: false,
    },
    timeLeft: {
      type: Number,
      default: 0,
    },
    time_restriction_media: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectedFileIdx: 0,
    }
  },
  computed: {
    images(){
      return this.files.filter(file => file.type.startsWith("image"));
    },
    isManyImages(){
      return this.images.length > 1;
    }
  },
  methods: {
    getFileUrl,
  },
  watch: {
    files: {
      handler: function () {
        this.selectedFileIdx = 0
      },
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: auto;
  border-radius: 10px;
  // max-height: 30vh;
}

.content-with-img-bg {
  position: relative;
}

.img-bg {
  width: 100%;
  filter: brightness(0.7) blur(0.5px);
  border-radius: 10px;
}

.content-audio-with-bg {
  position: absolute;
  width: 100%;
  top: calc(50% - 54px);
  left: 0;
  padding: 0 10px;
}

.viewer {

  .selected {
    width: 100%;
    margin: 0 auto;
  }

  .preview {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 16px;

    &__block {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 80px;
      padding: 4px;
      border: 1px solid $dark-gray-old;
      border-radius: 12px;

      &--selected {
        border: 2px solid $primary-old;
      }
    }
  }
}

.mh-inherit {
  max-height: inherit;
}
</style>